import { teamContext } from "@redotech/feature-flags-model/context";
import { featureFlag } from "@redotech/openfeature-contracts/flag";

/** Merchant-app unified onboarding shell (MAR-502). */
export const unifiedOnboardingFlag = featureFlag(
  "unified-onboarding",
  teamContext,
).boolean(false);

/** The new OMS onboarding flow; off shows Calendly. */
export const merchantOnboardingOmsFlag = featureFlag(
  "merchant-onboarding-oms",
  teamContext,
).boolean(false);
